import { render, staticRenderFns } from "./PortalGeoTooltip.vue?vue&type=template&id=24a238d0&scoped=true&"
import script from "./PortalGeoTooltip.vue?vue&type=script&lang=js&"
export * from "./PortalGeoTooltip.vue?vue&type=script&lang=js&"
import style0 from "./PortalGeoTooltip.vue?vue&type=style&index=0&id=24a238d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a238d0",
  null
  
)

export default component.exports